module.exports = __webpack_public_path__ + "b95333ec.png";